// extracted by mini-css-extract-plugin
export default {"navigater":"navigater_navigater__G9doY","path":"navigater_path__K2njc"};